import { render, staticRenderFns } from "./newOld.vue?vue&type=template&id=1732a044"
import script from "./newOld.vue?vue&type=script&lang=js"
export * from "./newOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports